<div class="header-row">
    <button mat-icon-button mat-dialog-close class="close-btn">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="dialog-title">
    <div class="dialog-sub-title">{{ I18N.NEW_FUNCTION | i18n | async }}</div>
    <div>{{ I18N.OUTBOUND_INFO_TITLE | i18n | async }}</div>
</div>
<mat-dialog-content>
    <div>{{ I18N.OUTBOUND_INFO_DESCRIPTION | i18n | async }}</div>
    <div class="title">{{ I18N.OUTBOUND_PRICE_TITLE | i18n | async }}</div>
    <div>{{ I18N.OUTBOUND_PRICE_DESCRIPTION | i18n | async }}</div>
</mat-dialog-content>
